'use client';

import styled from '@emotion/styled';
import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';
import { BaseLayout } from '@/app/base-layout';
import { HomeLayout } from '@/app-components/common/layout/HomeLayout';
import { Button } from 'ui-components/common/Button';
import { Error as ErrorComponent } from 'ui-components/common/Error';
import { PageTitle } from 'ui-components/common/PageTitle';

export default function GlobalError({ error, reset }: { error: Error; reset: () => void }) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <BaseLayout>
      <HomeLayout>
        <PageTitle title="" />
        <StyledWrap>
          <ErrorComponent title="요청을 처리하지 못했어요." description="잠시 후에 다시 요청해 주세요.">
            <StyledButton label="다시 시도" onClick={() => reset?.()} />
          </ErrorComponent>
        </StyledWrap>
      </HomeLayout>
    </BaseLayout>
  );
}

const StyledWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const StyledButton = styled(Button)`
  width: 240px;

  > * {
    width: 100%;
  }
`;
